import "../loginSignup/loginSignup.scss";
import signup_bg from "../../assets/img/login_bg.jpg";
import logo from "../../assets/img/logo.svg";
import password_show from "../../assets/img/password_show.svg";
import { useDispatch, useSelector } from "react-redux";
import { loginApp } from "../../redux/action";
import { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import Loading from "react-fullscreen-loading";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import {
  DISABLE_TWO_STEP_VERIFICATION,
  VERIFY_TWO_STEP_VERIFICATION,
} from "../../action/apiPath";
import { CallWithAuth } from "../../action/apiActions";
import { type } from "@testing-library/user-event/dist/type";
import { ADMIN, DOCTOR } from "../../util/constant";
import {  ADMINPROMPTPAGE } from "../../util/path";

const Login = () => {
  const subscription_id = localStorage.getItem("subscription_id");
  const info = localStorage.getItem("info");

  let parsedInfo = [];

  if (info) {
    try {
      parsedInfo = JSON.parse(info); // Only parse if 'info' exists
    } catch (error) {
      console.error("Invalid JSON in localStorage for 'info'", error);
      parsedInfo = []; // Default to empty array if JSON is invalid
    }
  } else {
    parsedInfo = []; // Default to empty array if 'info' is not found
  }

  // Now 'parsedInfo' is either the parsed value or an empty array
  const navigate = useNavigate();
  // __________ selector from redux __________
  const selector = useSelector((state) => state.GET_INFO_REDUCER);
  // __________ selector from redux __________

  // __________ state management __________
  const [consent, setConsent] = useState(false);
  const [emailError, setEmailError] = useState(null);
  const [passwordError, setPasswordError] = useState(null);
  const [constError, setConstError] = useState(null);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isVerfifyGoogleAuth, setIsVerfifyGoogleAuth] = useState(false);
  const [value, setValue] = useState(""); // State to store the input value
  const [userId, setUserId] = useState(null);

  const [loginDetail, setLoginDetail] = useState({
    email: null,
    password: null,
  });
  // __________ state management __________

  // __________ Rememberme Function __________

  useEffect(() => {
    const loginCookie = Cookies.get("login");

    if (loginCookie) {
      // Check if the cookie exists
      try {
        const savedLoginData = JSON.parse(loginCookie);
        if (savedLoginData.consent) {
          setLoginDetail((prevState) => ({
            ...prevState,
            email: savedLoginData.email,
            password: savedLoginData.password,
          }));

          setConsent(savedLoginData.consent);
        }
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    } else {
      console.log("No login cookie found");
    }
    setIsVerfifyGoogleAuth(false)

    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
        if (localStorage.getItem("role") == "admin") {
          navigate("/admin/prompts");
        } else {
          navigate("/");
        }
    }
  }, []);

  // __________ Rememberme Function __________

  // __________ handleFunction __________

  const handleEmail = (e) => {
    setLoginDetail((prevState) => ({
      ...prevState, // Spread the previous state to keep the password
      email: e.target.value, // Update the email
    }));
  };

  const handlePassword = (e) => {
    setLoginDetail((prevState) => ({
      ...prevState, // Spread the previous state to keep the password
      password: e.target.value, // Update the email
    }));
  };

  const handleLoginEffect = () => {
    if (selector.error == null) {
      if (selector.data != null) {
        toast.success(selector.message, {
          autoClose: 2000,
          position: "bottom-right",
        });
        setTimeout(() => {
          // / Check if access_token is missing
          console.log('Selector', selector?.data);

          if (!selector?.data?.access_token) {
            // Set TFA state to false and redirect to verify OTP
            localStorage.setItem("is_tfa", true);
            setIsVerfifyGoogleAuth(true);
            setUserId(selector?.data?.id);
            // navigate("/verify-otp");
            // return; // Prevent further execution
          } else {
            if ( selector?.data?.user?.role == ADMIN ) {
              navigate(`${ADMINPROMPTPAGE}`)
            } else if (selector?.data?.user?.role == DOCTOR){
              localStorage.setItem("is_tfa", false);
              // navigate('/patient-information')
              subscription_id !== null && subscription_id !== "null"
                ? info !== null && info !== "null"
                  ? navigate("/")
                  : // navigate("/manage-patient")
                  navigate("/create-account")
                : // navigate("/create-account")
                  navigate("/subscription");
            }            
          }
          // navigate("/subscription"); // Navigate after 2 seconds
        }, 1000);
      }
    } else {
      toast.error(selector.error, {
        autoClose: 2000,
        position: "bottom-right",
      });
    }
  };

  // __________ handleFunction __________

  // __________ Redux Action __________
  const dispatch = useDispatch();

  const handleSubmitFormLogin = async (event) => {
    event.preventDefault();

    let isError = false;
    setEmailError("");
    setPasswordError("");
    setConstError("");

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!loginDetail.email) {
      setEmailError("* Email is required.");
      isError = true;
    } else if (!emailRegex.test(loginDetail.email)) {
      setEmailError("* Invalid email format.");
      isError = true;
    }

    // Password validation (for example, a minimum of 8 characters)
    if (!loginDetail.password) {
      setPasswordError("* Password is required.");
      isError = true;
    }
    // } else if (loginDetail.password.length < 8) {
    //   setPasswordError("* Password must be at least 8 characters long.");
    //   isError = true;
    // }

    if (isError) return;

    let loginDetailLowecase = { email: loginDetail.email.trim().toLowerCase(), password: loginDetail.password, rememberMe: consent };
    // loginDetail.email = loginDetail.email.trim().toLowerCase();
    dispatch(loginApp({ consent, ...loginDetailLowecase }));
  };
  // __________ Redux Action __________

  useEffect(() => {
    handleLoginEffect();
  }, [selector]);

  const handleLoginNew = async () => {
    if (value.length == 6) {
      const body = {
        code: value,
      };
      const response = await CallWithAuth(
        "POST",
        VERIFY_TWO_STEP_VERIFICATION + `/${userId}`,
        body
      );

      if (response?.res?.data?.statusCode === 200) {
        let responseDetail = response?.res?.data?.data;
        console.log('Response Detail', responseDetail);

        // setIsEnabled(false);
        localStorage.setItem("is_tfa", true);
        if (consent) {
          Cookies.set("login", JSON.stringify({type:'GET_INFO',data:{
            email:responseDetail?.user?.email,        
          }}));
        }

        localStorage.setItem(
          "accessToken",
          response?.res?.data?.data?.access_token
        );
        localStorage.setItem("email", response?.res?.data.data.user.email);
        if(response.res.data.data.user.subscription) {
          localStorage.setItem(
            "subscription_id",
            response.res.data.data.user.subscription.subscription_id
          );
        }
        localStorage.setItem(
          "info",
          JSON.stringify(response?.res?.data?.data?.user?.info)
        );
        localStorage.setItem(
          "role",
          response?.res?.data?.data?.user?.role
        );
        toast.success(response?.res?.data?.message);
       if(response.res.data.data.user.subscription) navigate("/") 
        else navigate("/subscription");
      } else {
        toast.error(response?.res?.data?.message);
      }
    } else {
      toast.error("Please enter a 6 digit valid code");
    }
  };

  const handleChange = (event) => {
    // Set the input value in the state on change
    const newValue = event.target.value;

    // Ensure the value is a number and has a maximum of 6 digits
    if (newValue.length <= 6 && /^[0-9]*$/.test(newValue)) {
      setValue(newValue); // Update state with the new value
    }
  };

  return (
    <>
      {/* {selector.isLoading && <Loading loading background="rgba(236, 240, 241, 0.7)" loaderColor="#3498db" />} */}

      <section class="login_signup_wrapper">
        <div class="img_colm">
          <div class="back_btn" onClick={() => navigate("/")}>
            <i class="fa-solid fa-chevron-left"></i>
          </div>
          <div class="img_block">
            <img src={signup_bg} alt="" />
          </div>
        </div>
        <div class="form_colm">
          <div class="inner_block">
            <img src={logo} alt="" class="logo_img" />
            <h1>Login</h1>
            <p>Create an account or log in to manage your business.</p>

            <form onSubmit={handleSubmitFormLogin} class="form_block">
              <div class="form_field">
                <div class="input_grp">
                  <label for="">Email <span className="text-danger">*</span></label>
                  <input
                    type="text"
                    onChange={handleEmail}
                    value={loginDetail.email}
                    disabled={isVerfifyGoogleAuth}
                  />
                </div>
                <span className="red_error">{emailError}</span>
              </div>

              {!isVerfifyGoogleAuth && (
                <>
                  {" "}
                  <div class="form_field">
                    <div class="input_grp">
                      <label for="">Password <span className="text-danger">*</span></label>
                      <div class="pass_field">
                        <input
                          type={isPasswordVisible ? "text" : "password"}
                          onChange={handlePassword}
                        />
                        <span
                          class={`show_hide_btn ${
                            !isPasswordVisible ? "hide" : ""
                          }`}
                          onClick={() =>
                            setIsPasswordVisible(!isPasswordVisible)
                          }
                        >
                          <img src={password_show} alt="" />
                        </span>
                      </div>
                      <span className="red_error">{passwordError}</span>
                    </div>
                  </div>
                  <div class="site_row">
                    <div class="input_grp">
                      <input
                        type="checkbox"
                        id="consentCheckbox"
                        className="customChk-s1"
                        checked={consent}
                        onChange={(e) => setConsent(e.target.checked)}
                      />
                      <label style={{ marginLeft: "5px" }} for="" htmlFor="consentCheckbox">
                        Remember Me
                      </label>
                    </div>

                    <Link to={`/forget-password`} class="forget_pass_link">
                      Forgot Password?
                    </Link>
                  </div>
                </>
              )}

              {isVerfifyGoogleAuth && (
                <>
                  <div class="form_field">
                    <div class="input_grp">
                      <label for="">Google authenticator otp</label>
                      <input
                        type="number"
                        onChange={handleChange}
                        value={value}
                        max={6}
                      />
                    </div>
                    <span className="red_error">{emailError}</span>
                  </div>
                </>
              )}
              {!isVerfifyGoogleAuth && (
                <>
                  <div class="btn_block">
                    <button type="submit">Login</button>
                  </div>
                </>
              )}

              {isVerfifyGoogleAuth && (
                <>
                  <div class="btn_block">
                    <button type="button" onClick={handleLoginNew}>
                      Google Authentication
                    </button>
                  </div>

                    {/* 👇 new button */}
                    <div class="btn_block">
                      <button
                        type="button"
                        className="back_btn"
                        onClick={() => {
                          setIsVerfifyGoogleAuth(false);
                          setValue("");
                          setUserId(null);
                        }}
                      >
                        Back to Login
                      </button>
                    </div>
                </>
              )}

              <p>
                Don’t have any account?{" "}
                <Link to={"/signup"}> &nbsp; Sign Up</Link>
              </p>
            </form>
          </div>
        </div>
      </section>

      <ToastContainer />
    </>
  );
};

export default Login;
